import React, { useState, useEffect } from 'react';
import '../../../css/huerto/scoringFilter.css';
import { withRouter } from 'react-router-dom';
import Input from '../../../bronson/Input';
import ModalOrdenar from './modalOrdenar';

function FilterVencimientosAsignados(props) {
    const [data, setData] = useState(props.data);
    const [dataContactados, setdataContactados] = useState(false);
    const [dataNoContactados, setdataNoContactados] = useState(false);
    const [modalOrden, setModalOrden] = useState(false);
    const [orden, setOrden] = useState(props.orden);

    useEffect(() => {
        setOrden(props.orden);
    }, [props.orden]);
    useEffect(() => {
        setData(props.data);
    }, [props.data]);

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);

    const onchangeMatricula = target => {
        props.changeFilterMatricula(target.target.value);
    };
    const tagOrden = () => {
        if (orden.length !== 2) return <div></div>;
        // type, option
        var text = '';
        switch (orden[1]) {
            case 'SC': //Score/Color Cliente
                text = 'Score C';
                break;
            case 'SV': //Score/Color Vehiculo
                text = 'Score V';
                break;
            case 'PC': // producto comercial
                text = 'Producto C';
                break;
            case 'FV': //fecha de vencimiento
                text = 'Fecha Vnt';
                break;
            case 'FI': //fecha IPO
                text = 'Fecha IPO';
                break;
            case 'AO': //asesor original -> SellerContractsFullName
                text = 'Asesor Org';
                break;
            case 'AA': // asesor asignado -> VendedorAsignado
                text = 'Asesor Asig';
                break;
        }
        return (
            <div className="o-layout scoring-filters-active-div o-layout--equal-height o-layout--flush">
                <span className="c-tag c-tag-filter UsuarioVendedorAsignado">
                    <span className="c-tag__label">
                        Orden: {text}({orden[0]})
                    </span>
                    <button
                        className="c-tag__close"
                        title="Cerrar"
                        type="button"
                        onClick={() => props.setOrden([])}
                    ></button>
                </span>
            </div>
        );
    };
    return (
        <div className="o-layout">
            {modalOrden && (
                <ModalOrdenar
                    setModalorden={setModalOrden}
                    setOrden={props.setOrden}
                    orden={props.orden}
                    viewDisplay={'ASignados'}
                />
            )}
            <div className="o-layout__item filterbuttonsContent">
                <div className="u-float-left u-1/1@m">
                    <div className="u-float-left">
                        <button
                            data-tippy-content={
                                'Ordena el listado de vencimientos.'
                            }
                            data-tippy-placement={''}
                            className={
                                'js-tooltip c-btn c-btn--secondary ' +
                                (orden.length === 2
                                    ? 'scoringFiltersBtn-active'
                                    : 'u-text-brand')
                            }
                            onClick={() => setModalOrden(!modalOrden)}
                        >
                            <i className="c-icon c-icon--[control-list-view] c-icon--small" />
                            <span className="c-btn__text mideltextfilter">
                                ORDENAR
                            </span>
                        </button>
                    </div>
                </div>
                <div className="u-float-right">
                    <button
                        className="c-btn  u-text-brand"
                        onClick={() =>
                            props.setViewDataVencimientoAsignado(true)
                        }
                        disabled={
                            props.dataTodosLosVencimientos.length > 1
                                ? false
                                : true
                        }
                    >
                        <span className="mideltextfilter">
                            VER LISTADO COMPLETO
                        </span>
                    </button>
                </div>
                <div className="u-float-right containerFilterVencimientoAsignado u-mr-small">
                    {false && (
                        <button
                            className="js-tooltip c-btn c-btn c-btn--secondary u-mr-small"
                            onClick={() => {
                                setdataContactados(!dataContactados);
                            }}
                            style={
                                dataContactados
                                    ? { backgroundColor: '#004666' }
                                    : {}
                            }
                            data-tippy-content={'Ver contactados.'}
                            data-tippy-placement={''}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14.795"
                                height="14.71"
                                viewBox="0 0 14.795 14.71"
                            >
                                <g
                                    id="_08_Icons_01_Control-16x16_01_Control-phone"
                                    data-name="08_Icons/01_Control-16x16/01_Control-phone"
                                    transform="translate(-0.555 -0.65)"
                                >
                                    <path
                                        id="Shape"
                                        d="M11.3,15.1A11.318,11.318,0,0,1,4.1,12C1.3,9.1-.1,4.3,1.5,2.3L2.9.9H5.1L6.6,5,4.8,6.7A5.88,5.88,0,0,0,6.5,9.5a5.47,5.47,0,0,0,2.8,1.7L11,9.5l4.1,1.4V13l-1.4,1.4A3.612,3.612,0,0,1,11.3,15.1ZM3.3,1.8,2.2,2.9c-1.1,1.4,0,5.7,2.7,8.3,2.5,2.6,6.7,3.6,8.2,2.5l1-1V11.6l-2.9-1L9.6,12.2H9.5c-.1,0-1.7,0-3.6-2-2-2-2-3.6-2-3.6V6.4L5.5,4.8l-1.1-3Z"
                                        fill={
                                            dataContactados
                                                ? 'white'
                                                : '#004666'
                                        }
                                        stroke={
                                            dataContactados
                                                ? 'white'
                                                : '#004666'
                                        }
                                        strokeWidth="0.5"
                                    />
                                </g>
                            </svg>
                        </button>
                    )}

                    {false && (
                        <button
                            className="js-tooltip c-btn c-btn c-btn--secondary u-mr-small"
                            onClick={() => {
                                setdataNoContactados(!dataNoContactados);
                            }}
                            style={
                                dataNoContactados
                                    ? { backgroundColor: '#004666' }
                                    : {}
                            }
                            data-tippy-content={'Ver no contactados.'}
                            data-tippy-placement={''}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14.795"
                                height="15.307"
                                viewBox="0 0 14.795 15.307"
                            >
                                <g
                                    id="Grupo_68432"
                                    data-name="Grupo 68432"
                                    transform="translate(-8.969 -12.469)"
                                >
                                    <g
                                        id="_08_Icons_01_Control-16x16_01_Control-phone-Copy-9"
                                        data-name="08_Icons/01_Control-16x16/01_Control-phone-Copy-9"
                                        transform="translate(9.24 12.719)"
                                    >
                                        <path
                                            id="Shape"
                                            d="M11.3,15.1A11.318,11.318,0,0,1,4.1,12C1.3,9.1-.1,4.3,1.5,2.3L2.9.9H5.1L6.6,5,4.8,6.7A5.88,5.88,0,0,0,6.5,9.5a5.47,5.47,0,0,0,2.8,1.7L11,9.5l4.1,1.4V13l-1.4,1.4A3.612,3.612,0,0,1,11.3,15.1ZM3.3,1.8,2.2,2.9c-1.1,1.4,0,5.7,2.7,8.3,2.5,2.6,6.7,3.6,8.2,2.5l1-1V11.6l-2.9-1L9.6,12.2H9.5c-.1,0-1.7,0-3.6-2-2-2-2-3.6-2-3.6V6.4L5.5,4.8l-1.1-3Z"
                                            transform="translate(-0.826 -0.9)"
                                            fill={
                                                dataNoContactados
                                                    ? 'white'
                                                    : '#004666'
                                            }
                                            stroke={
                                                dataNoContactados
                                                    ? 'white'
                                                    : '#004666'
                                            }
                                            strokeWidth="0.5"
                                        />
                                    </g>
                                    <rect
                                        id="Rectangle"
                                        width="1"
                                        height="17"
                                        transform="translate(20.847 13.979) rotate(42)"
                                        fill={
                                            dataNoContactados
                                                ? 'white'
                                                : '#004666'
                                        }
                                        stroke={
                                            dataNoContactados
                                                ? 'white'
                                                : '#004666'
                                        }
                                        strokeWidth="0.7"
                                    />
                                </g>
                            </svg>
                        </button>
                    )}
                    <div
                        className="input-div u-hide@s"
                        onChange={onchangeMatricula}
                    >
                        <Input
                            options={{
                                id: 'matricula',
                                type: 'text',
                                placeHolder: 'Buscar por matrícula',
                                autoComplete: 'off',
                            }}
                            onChange={() => {}}
                        />
                    </div>
                </div>
            </div>
            <div className="o-layout__item  u-1/1">{tagOrden()}</div>
        </div>
    );
}
export default withRouter(FilterVencimientosAsignados);
